import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({
  standalone: false,
  name: 'ingsvSanitizeHtml',
})
export class SanitizeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (value == null || value === '') {
      return '';
    }
    const str = typeof value === 'string' ? value : String(value);
    const cleaned = DOMPurify.sanitize(str, { USE_PROFILES: { html: true } });
    return this.sanitizer.bypassSecurityTrustHtml(cleaned);
  }
}
